import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { FORGET_USER, RESET_PASSWORD } from "./actionTypes";
import { forgetUserSuccessful, isLoadingForgetUser, userForgetPasswordError } from "./actions";

import { resetPass, sendOTP } from "../../../api/authAPI";

//If user is login then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    yield put(isLoadingForgetUser());
    const response = yield call(sendOTP, user.useremail);
    if (response) {
      yield put(forgetUserSuccessful({ email: user.useremail, msg: "One-time code is sent to your mailbox, Please Check" }));
      history.push("/reset-password");
    } else {
      yield put({ isErr: true, msg: "Error in sending OTP, Please check your email and try again..." });
    }
  } catch (error) {
    yield put(userForgetPasswordError(error));
  }
}

function* resetPassWord({ payload: { user, history } }) {
  try {
    console.log("reset Password: ", user);

    // history.push("/reset-status");
    const response = yield call(resetPass, { ...user });
    if (response) {
      history.push({
        pathname: "/reset-status",
        state: { isSuccess: true },
      });
    } else {
      yield put({ isErr: true, msg: "Error in sending OTP, Please check your email and try again..." });
      history.push({
        pathname: "/reset-status",
        state: { isSuccess: false },
      });
    }
  } catch (error) {
    history.push({
      pathname: "/reset-status",
      state: { isSuccess: false },
    });
    yield put(userForgetPasswordError(error));
  }
}
export function* watchUserForget() {
  yield takeEvery(FORGET_USER, forgetUser);
}
export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassWord);
}
function* forgetSaga() {
  yield all([fork(watchUserForget), fork(watchResetPassword)]);
}

export default forgetSaga;
